import api from '../api'

export default {
    namespaced: true,
    state: {
        manualRechargePayChannelChipsList: {
            beanList: [],
            total: 0
        },
        totalAbsRechargeChip: 0
    },
    mutations: {
        setStateManualRechargePayChannelChipsList(state, info) {
            state.manualRechargePayChannelChipsList = info
        },
        setStateTotalAbsRechargeChip(state,info){
            state.totalAbsRechargeChip = info.totalAbsRechargeChip
        }
    },
    actions: {
        getPayChannelInfo(store, params) {
            return api.post('/manualRechargePayChannelChips/getPayChannelInfo', '渠道信息', params)
        },
        doManualRecharge(store, params) {
            return api.post('/manualRechargePayChannelChips/doManualRecharge', '手动充豆', params)
        },
        getManualRechargePayChannelChipsList({commit, dispatch}, params) {
            return api.post('/manualRechargePayChannelChips/list', '手动充豆', params).then(res => {
                commit('setStateManualRechargePayChannelChipsList', res.data);
                dispatch('getManualRechargePayChannelChipsSum',params)
            })
        },
        getManualRechargePayChannelChipsSum({commit}, params) {
            return api.post('/manualRechargePayChannelChips/sum', '充豆统计', params).then(res => {
                commit('setStateTotalAbsRechargeChip', res.data)
            })
        },
        updateRechargeStatus(store, params) {
            return api.post('/manualRechargePayChannelChips/updateRechargeStatus', '更新充豆状态', params)
        }
    }
}